import React from "react";
import "./AmountCountAvg.css";
import { formatter2 } from "../../../../utils/helpers";

export const AmountCountAvg = ({ data = [] }) => {
  return (
    <div className="amount-count-avg">
      {data.map((item, idx) => (
        <div key={idx} className="aca-row">
          <span className="aca-label">
            {item?.label || `#${idx + 1}`}
          </span>

          <span className="aca-values">
            <span>{formatter2.format(item?.value ?? 0)}</span>
            <span>{formatter2.format(item?.value2 ?? 0)}</span>
            <span>{formatter2.format(item?.value3 ?? 0)}</span>
          </span>
        </div>
      ))}
    </div>
  );
};
